<template>
  <div
      v-if="enable"
      class="pagination-bar"
  >
    <!-- mobile navigation -->
    <nav v-if="isMobile && conf.mobile.enable">
      <ul class="pagination pagination-lg p-center d-sm-none">
        <!-- previous page -->
        <li v-if="conf.showNextPrevious && 1 !== currentPage">
          <a class="page-link" @click="updatePage(currentPage - 1)">
            <i class="fa fa-chevron-left"></i>
            <span>{{ $t('messages_nl.global.previous') }}</span>
          </a>
        </li>
        <!-- /previous page -->

        <!-- next page -->
        <li v-if="conf.showNextPrevious && lastPage !== currentPage">
          <a class="page-link" @click="updatePage(currentPage + 1)">
            <span>{{ $t('messages_nl.global.next') }}</span>
            <i class="fa fa-chevron-right"></i>
          </a>
        </li>
        <!-- /next page -->
      </ul>
    </nav>
    <!-- /mobile navigation -->

    <!-- desktop navigation -->
    <nav v-else>
      <ul class="advanced pagination pagination-lg d-none d-sm-flex">
        <!-- previous page -->
        <li v-if="conf.showNextPrevious && 1 !== currentPage">
          <a class="page-link" @click="updatePage(currentPage - 1)">
            <i class="fa fa-chevron-left"></i>
          </a>
        </li>
        <!-- /previous page -->

        <!-- first page-->
        <li v-if="conf.showFirstPage && !atStart"
            class="page-item"
        >
          <a class="page-link" @click="updatePage(1)">1</a>
        </li>
        <!-- /first page -->

        <!-- dots start-->
        <li v-if="conf.showFirstPage && !atStart">
          <span class="page-link">...</span>
        </li>
        <!-- /dots start -->

        <!-- pages-->
        <li v-for="page in pageNumbers"
            :key="page"
            :class="['page-item', { active: page === currentPage }]"
        >
          <a class="page-link" @click="updatePage(page)">{{ page }}</a>
        </li>
        <!-- /pages -->

        <!-- dots end-->
        <li v-if="conf.showLastPage && !atEnd">
          <span class="page-link">...</span>
        </li>
        <!-- /dots end -->

        <!-- last page-->
        <li v-if="conf.showLastPage && !atEnd"
            class="page-item"
        >
          <a class="page-link" @click="updatePage(lastPage)">{{ lastPage }}</a>
        </li>
        <!-- /last page -->

        <!-- next page -->
        <li v-if="conf.showNextPrevious && lastPage !== currentPage">
          <a class="page-link" @click="updatePage(currentPage + 1)">
            <i class="fa fa-chevron-right"></i>
          </a>
        </li>
        <!-- /next page -->
      </ul>
    </nav>
    <!-- /desktop navigation -->
  </div>
</template>

<script>
import MainJS from '/assets/common/vue/components-js/pagination-bar';

export default {
  extends: MainJS
}
</script>
